export default __webpack_public_path__ + "5cfa12bb53f02bb20de094c52f112550.jpg";